(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbc-hsa-fsa-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var el = e.target.closest && e.target.closest('.bbchb [data-bbchb-track]');
  if (!el) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'hsa_fsa_lp', hsa_action: el.getAttribute('data-bbchb-track'), hsa_label: el.textContent.trim() });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-hsa-fsa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(cents) {
    return '$' + (Math.round(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function init(root) {
    var calc = root.querySelector('[data-bbch-calc]');
    if (!calc || calc.dataset.ready) return;
    calc.dataset.ready = '1';
    var bike = calc.querySelector('[data-bbch-bike]');
    var rate = calc.querySelector('[data-bbch-rate]');
    var rateOut = calc.querySelector('[data-bbch-rate-out]');
    var save = calc.querySelector('[data-bbch-save]');
    var net = calc.querySelector('[data-bbch-net]');
    var shop = calc.querySelector('[data-bbch-shop]');
    var shopName = calc.querySelector('[data-bbch-shop-name]');
    function update() {
      var price = parseInt(bike.value, 10) || 0;
      var r = parseInt(rate.value, 10) || 0;
      var s = Math.floor(price * r / 100);
      var opt = bike.options[bike.selectedIndex];
      rateOut.textContent = r + '%';
      save.textContent = fmt(s);
      net.textContent = fmt(price - s);
      if (shop && opt && opt.dataset.url) {
        shop.href = opt.dataset.url;
        shop.setAttribute('data-bbch-label', opt.dataset.url.split('/').pop());
        shopName.textContent = opt.dataset.name;
      }
    }
    bike.addEventListener('change', function () { update(); track('estimator_bike', bike.options[bike.selectedIndex].dataset.name); });
    rate.addEventListener('input', update);
    rate.addEventListener('change', function () { track('estimator_rate', rate.value); });
    update();
  }
  function track(action, label) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'hsa_fsa_lp', hsa_action: action, hsa_label: label || '' });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.bbch [data-bbch-track]');
    if (el) track(el.getAttribute('data-bbch-track'), el.getAttribute('data-bbch-label') || el.textContent.trim());
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.classList && d.classList.contains('bbch-faq__item') && d.open) {
      var q = d.querySelector('.bbch-faq__q');
      track('faq_open', q ? q.textContent.trim() : '');
    }
  }, true);
  function boot() {
    document.querySelectorAll('[data-bbch-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
